/* Furlo product page script. Data comes from the #fpData JSON tag in sections/furlo-product.liquid */
(function(){
  "use strict";
  var dataEl = document.getElementById('fpData');
  if(!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var P = D.product, SYM = D.sym, ETA = D.eta;
  function money(c){ return SYM + (c/100).toFixed(2); }
  function $(id){ return document.getElementById(id); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* mobile menu */
  var menuBtn = $('fpMenuBtn'), mnav = $('fpMobileNav');
  if(menuBtn){ menuBtn.addEventListener('click', function(){ var o = mnav.classList.toggle('open'); menuBtn.setAttribute('aria-expanded', o ? 'true' : 'false'); }); }

  /* gallery */
  var slides = $('fpSlides');
  var thumbs = document.querySelectorAll('.fp-thumb');
  var countLabel = $('fpCountLabel');
  var total = slides ? slides.children.length : 0;
  function currentIndex(){ return slides ? Math.round(slides.scrollLeft / Math.max(slides.clientWidth,1)) : 0; }
  function goTo(i, smooth){
    if(!slides) return;
    i = Math.max(0, Math.min(total - 1, i));
    slides.scrollTo({ left: i * slides.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function syncGallery(){
    var i = currentIndex();
    thumbs.forEach(function(t, k){ t.classList.toggle('active', k === i); });
    if(countLabel) countLabel.textContent = (i + 1) + ' / ' + total;
    var active = thumbs[i];
    if(active && active.parentNode){ var p = active.parentNode; p.scrollTo({left: active.offsetLeft - p.clientWidth/2 + active.clientWidth/2, behavior:'smooth'}); }
  }
  if(slides){
    var st; slides.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(syncGallery, 60); }, {passive:true});
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(+t.getAttribute('data-index')); }); });
    if($('fpPrev')) $('fpPrev').addEventListener('click', function(){ goTo(currentIndex() - 1); });
    if($('fpNext')) $('fpNext').addEventListener('click', function(){ goTo(currentIndex() + 1); });
    document.querySelectorAll('.fp-sidecard').forEach(function(c){ c.addEventListener('click', function(){ goTo(+c.getAttribute('data-goto')); }); });
    window.addEventListener('resize', function(){ goTo(currentIndex(), false); });
  }
  function showMedia(mediaId){
    if(!slides || !mediaId) return;
    var kids = slides.children;
    for(var k = 0; k < kids.length; k++){ if(kids[k].getAttribute('data-media-id') == String(mediaId)){ goTo(k); return; } }
  }

  /* variants */
  function findVariant(opts){
    for(var i = 0; i < P.variants.length; i++){
      var v = P.variants[i], ok = true;
      for(var j = 0; j < opts.length; j++){ if(v.options[j] !== opts[j]){ ok = false; break; } }
      if(ok) return v;
    }
    return null;
  }
  function imgUrl(src, w){
    if(!src) return '';
    if(src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function variantImg(v){ return imgUrl((v && v.featured_image && v.featured_image.src) || P.featured_image || '', 140); }
  var colorIdx = -1;
  P.options.forEach(function(n, i){ if(colorIdx < 0 && /colo/i.test(n)) colorIdx = i; });
  function swatchFor(val){
    for(var i = 0; i < P.variants.length; i++){
      var v = P.variants[i];
      if(v.options[colorIdx] === val && v.featured_image) return imgUrl(v.featured_image.src, 60);
    }
    return '';
  }
  var optionValues = P.options.map(function(name, oi){
    var vals = [];
    P.variants.forEach(function(x){ if(vals.indexOf(x.options[oi]) === -1) vals.push(x.options[oi]); });
    return vals;
  });
  function valueAvailable(opts, oi, val){
    return P.variants.some(function(v){
      if(!v.available || v.options[oi] !== val) return false;
      for(var j = 0; j < oi; j++){ if(v.options[j] !== opts[j]) return false; }
      return true;
    });
  }
  /* after a change, move later options to something in stock if needed */
  function fixLater(opts, from){
    for(var oi = from + 1; oi < opts.length; oi++){
      if(!valueAvailable(opts, oi, opts[oi])){
        for(var k = 0; k < optionValues[oi].length; k++){ if(valueAvailable(opts, oi, optionValues[oi][k])){ opts[oi] = optionValues[oi][k]; break; } }
      }
    }
  }

  var startId = D.startId;
  var first = null;
  P.variants.forEach(function(v){ if(v.id === startId) first = v; });
  if(!first) first = P.variants[0];
  var items = [ first.options.slice() ];   /* chosen options for hoodie 1, 2, 3 */
  var selected = first;
  var addBtn = $('fpAdd'), stickyAdd = $('fpStickyAdd'), errBox = $('fpError');

  /* bundles */
  var bundleWrap = $('fpBundles');
  var bundleBoxes = document.querySelectorAll('.fp-bundle');
  var qty = 1, pct = 0;
  /* extra hoodies start in a different colour (next in the list that's in stock) */
  function newItem(i){
    var o = items[0].slice();
    if(colorIdx > -1){
      var vals = optionValues[colorIdx], start = vals.indexOf(o[colorIdx]);
      var used = items.slice(0, i).map(function(x){ return x[colorIdx]; });
      for(var k = 1; k < vals.length; k++){
        var c = vals[(start + k) % vals.length];
        if(used.indexOf(c) === -1 && valueAvailable(o, colorIdx, c)){ o[colorIdx] = c; fixLater(o, colorIdx); break; }
      }
    }
    return o;
  }
  function bundleItems(){
    var list = [];
    for(var i = 0; i < qty; i++){ if(!items[i]) items[i] = newItem(i); list.push(findVariant(items[i])); }
    return list;
  }
  function itemNow(price, p){ return price - Math.floor(price * p / 100); }
  function priceFor(list, p){
    var full = 0, now = 0; list.forEach(function(v){ if(v){ full += v.price; now += itemNow(v.price, p); } });
    return { full: full, now: now };
  }
  function rowsHTML(q){
    var h = '<div class="fp-rows-head"><span>' + esc(P.options.join(', ')) + '</span>' +
      (D.sizeGuide ? '<button type="button" class="fp-size-link" data-open-size>Size guide</button>' : '') + '</div>';
    for(var i = 0; i < q; i++){
      if(!items[i]) items[i] = newItem(i);
      var opts = items[i], v = findVariant(opts);
      h += '<div class="fp-row" data-i="' + i + '"><img alt="" src="' + esc(variantImg(v)) + '">';
      P.options.forEach(function(name, oi){
        var isC = oi === colorIdx;
        h += '<label class="fp-sel' + (isC ? ' has-sw' : '') + '">';
        if(isC){ var sw = swatchFor(opts[oi]); h += '<span class="sw"' + (sw ? ' style="background-image:url(\'' + esc(sw) + '\')"' : '') + '></span>'; }
        h += '<select data-oi="' + oi + '" aria-label="' + esc(name) + (q > 1 ? ' for hoodie ' + (i + 1) : '') + '">';
        optionValues[oi].forEach(function(val){
          var ok = valueAvailable(opts, oi, val);
          h += '<option value="' + esc(val) + '"' + (val === opts[oi] ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(val) + (ok ? '' : ' (sold out)') + '</option>';
        });
        h += '</select></label>';
      });
      h += '</div>';
    }
    if(D.fitNote) h += '<p class="fp-fitnote">' + esc(D.fitNote) + '</p>';
    return h;
  }
  function activeBox(){
    for(var k = 0; k < bundleBoxes.length; k++){ if(bundleBoxes[k].classList.contains('active')) return bundleBoxes[k]; }
    return null;
  }
  function drawRows(){
    bundleBoxes.forEach(function(b){
      var body = b.querySelector('.fp-bundle-body');
      if(body) body.innerHTML = b.classList.contains('active') ? rowsHTML(+b.getAttribute('data-q')) : '';
    });
  }
  function chooseBundle(box){
    qty = +box.getAttribute('data-q'); pct = +box.getAttribute('data-pct');
    bundleBoxes.forEach(function(b){
      var on = b === box;
      b.classList.toggle('active', on);
      var h = b.querySelector('.fp-bundle-head'); if(h) h.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    drawRows();
    render();
  }
  bundleBoxes.forEach(function(b){
    var h = b.querySelector('.fp-bundle-head');
    if(h) h.addEventListener('click', function(){ if(!b.classList.contains('active')) chooseBundle(b); });
  });
  if(bundleWrap){
    bundleWrap.addEventListener('change', function(e){
      var s = e.target;
      if(!s || s.tagName !== 'SELECT') return;
      var row = s.closest('.fp-row'); if(!row) return;
      var i = +row.getAttribute('data-i'), oi = +s.getAttribute('data-oi');
      items[i][oi] = s.value;
      fixLater(items[i], oi);
      drawRows();
      render(i === 0 ? true : undefined);
      var again = bundleWrap.querySelector('.fp-row[data-i="' + i + '"] select[data-oi="' + oi + '"]');
      if(again) again.focus();
    });
  }

  function render(changedFirst){
    selected = findVariant(items[0]);
    var price = $('fpPrice'), was = $('fpWas'), save = $('fpSave'), sp = $('fpStickyPrice');
    if(selected){
      price.textContent = money(selected.price);
      var sale = selected.compare_at_price && selected.compare_at_price > selected.price;
      if(was && save){
        was.hidden = !sale; save.hidden = !sale;
        if(sale){ was.textContent = money(selected.compare_at_price); save.textContent = 'Save ' + Math.round((selected.compare_at_price - selected.price) / selected.compare_at_price * 100) + '%'; }
      }
      if(changedFirst && selected.featured_media) showMedia(selected.featured_media.id);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', selected.id); history.replaceState(null, '', u.toString()); } catch(e){}
    }
    bundleBoxes.forEach(function(b){
      var q = +b.getAttribute('data-q'), p = +b.getAttribute('data-pct');
      var unit = selected ? selected.price : P.price;
      var full = unit * q, now = q * itemNow(unit, p);
      var n = b.querySelector('[data-now]'); if(n) n.textContent = money(now);
      var w = b.querySelector('[data-was]'); if(w) w.textContent = p ? money(full) : '';
      var sv = b.querySelector('[data-save]'); if(sv) sv.textContent = 'You save ' + money(full - now);
    });
    var list = bundleItems();
    var allOk = list.every(function(v){ return v && v.available; });
    var t = priceFor(list, pct);
    addBtn.disabled = !allOk; addBtn.textContent = allOk ? 'Add to cart' : 'Sold out – pick another option';
    if(stickyAdd){ stickyAdd.disabled = !allOk; stickyAdd.textContent = allOk ? 'Add to cart' : 'Sold out'; }
    if(sp) sp.textContent = money(t.now) + (qty > 1 ? ' for ' + qty : '');
    if(errBox) errBox.hidden = true;
  }
  (function initBundle(){
    var want = bundleWrap ? +bundleWrap.getAttribute('data-default') : 1;
    var box = null;
    bundleBoxes.forEach(function(b){ if(+b.getAttribute('data-q') === want) box = b; });
    if(!box && bundleBoxes.length) box = bundleBoxes[0];
    if(box) chooseBundle(box); else render();
  })();

  /* welcome code */
  var copy = $('fpCopy');
  if(copy){ copy.addEventListener('click', function(){ try { navigator.clipboard.writeText(copy.getAttribute('data-code')); } catch(e){} copy.textContent = 'Copied ✓'; setTimeout(function(){ copy.textContent = 'Copy code'; }, 2000); }); }

  /* delivery estimate (working days) */
  function addWorkingDays(d, n){ var r = new Date(d); var added = 0; while(added < n){ r.setDate(r.getDate() + 1); var w = r.getDay(); if(w !== 0 && w !== 6) added++; } return r; }
  function fmt(d){ return d.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' }); }
  var eta = $('fpEta');
  if(eta && ETA.dmin != null){ var now = new Date(); eta.textContent = 'Order today: estimated delivery ' + fmt(addWorkingDays(now, ETA.dmin + ETA.tmin)) + ' – ' + fmt(addWorkingDays(now, ETA.dmax + ETA.tmax)); }

  /* size guide */
  var dlg = $('fpSizeDialog');
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-open-size]') : null;
    if(!b) return;
    e.preventDefault();
    if(dlg && dlg.showModal){ dlg.showModal(); } else { var d = $('details'); if(d) d.scrollIntoView({behavior:'smooth'}); }
  });
  if(dlg){
    dlg.querySelectorAll('[data-close-size]').forEach(function(b){ b.addEventListener('click', function(){ dlg.close(); }); });
    dlg.addEventListener('click', function(e){ if(e.target === dlg) dlg.close(); });
  }

  /* FAQ accordion */
  var faq = $('fpFaq');
  if(faq){
    var accs = faq.querySelectorAll('.acc-item');
    accs.forEach(function(item){
      var trig = item.querySelector('.acc-trigger'), panel = item.querySelector('.acc-panel');
      trig.addEventListener('click', function(){
        var open = !item.classList.contains('open');
        accs.forEach(function(i){ i.classList.remove('open'); i.querySelector('.acc-panel').style.maxHeight = '0px'; i.querySelector('.acc-trigger').setAttribute('aria-expanded','false'); });
        if(open){ item.classList.add('open'); panel.style.maxHeight = panel.scrollHeight + 'px'; trig.setAttribute('aria-expanded','true'); }
      });
    });
  }

  /* cart */
  var overlay = $('fpOverlay'), drawer = $('fpCart'), list = $('fpCartItems'), countEl = $('fpCartCount');
  function openCart(){ overlay.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); }
  function closeCart(){ overlay.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); }
  function renderCart(c){
    countEl.textContent = c.item_count; countEl.hidden = !c.item_count;
    $('fpCartTotal').textContent = money(c.total_price);
    var disc = c.total_discount || 0;
    $('fpCartDisc').hidden = !(disc > 0); if(disc > 0) $('fpCartDiscVal').textContent = '−' + money(disc);
    var co = $('fpCheckout'); co.style.opacity = c.item_count ? '' : '.5'; co.style.pointerEvents = c.item_count ? '' : 'none';
    if(!c.items || !c.items.length){ list.innerHTML = '<div class="mc-empty">Your cart is empty.</div>'; return; }
    list.innerHTML = c.items.map(function(it){
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var sub = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
      var price = (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price);
      return '<div class="mc-item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') +
        '<div class="mc-info"><div class="mc-name">' + esc(it.product_title) + '</div>' +
        '<div class="mc-sub">' + (sub ? sub + ' · ' : '') + 'Qty ' + it.quantity + '</div>' +
        '<button type="button" class="mc-remove" data-key="' + esc(it.key) + '">Remove</button></div>' +
        '<div class="mc-price">' + price + '</div></div>';
    }).join('');
    list.querySelectorAll('.mc-remove').forEach(function(b){
      b.addEventListener('click', function(){
        b.disabled = true;
        fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: 0 }) })
          .then(function(r){ return r.json(); }).then(renderCart).catch(function(){ b.disabled = false; });
      });
    });
  }
  function loadCart(){ return fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(function(r){ return r.json(); }).then(function(c){ renderCart(c); return c; }); }
  function addToCart(){
    var list = bundleItems();
    if(!list.every(function(v){ return v && v.available; })) return;
    var merged = {};
    list.forEach(function(v){ merged[v.id] = (merged[v.id] || 0) + 1; });
    var payload = Object.keys(merged).map(function(id){ return { id: +id, quantity: merged[id] }; });
    addBtn.disabled = true; addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: payload }) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ $('fpCartTitle').textContent = 'Added to cart ✓'; return loadCart(); })
      .then(function(){ openCart(); render(); })
      .catch(function(e){ render(); if(errBox){ errBox.textContent = (e && e.description) || 'Sorry, that didn’t work. Please try again.'; errBox.hidden = false; } });
  }
  addBtn.addEventListener('click', addToCart);
  if(stickyAdd) stickyAdd.addEventListener('click', addToCart);
  $('fpCartOpen').addEventListener('click', function(){ $('fpCartTitle').textContent = 'Your cart'; loadCart().then(openCart); });
  $('fpCartClose').addEventListener('click', closeCart);
  $('fpContinue').addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCart(); });
  loadCart().catch(function(){});

  /* sticky bar when the main button is off screen */
  var sticky = $('fpSticky');
  if(sticky && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var e = en[0]; var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(addBtn);
  }
})();
